module.exports = __webpack_public_path__ + "static/media/ventajasdetox_mob.af880c1b.svg";